"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
class SampleCoreMetadata {
    constructor() {
        this.date = null;
        this.plant_year = null;
        this.soil_type_id = null;
        this.org_practises = null;
        this.art_irrigation = null;
        this.bio_methods = null;
        this.density = null;
        this.variety = null;
        this.parcel_name = null;
    }
    static fromRaw(raw) {
        const meta = new SampleCoreMetadata();
        if (raw.date)
            meta.date = (0, moment_1.default)(raw.date.substr(0, 10)).toDate();
        if (raw.plant_year)
            meta.plant_year = +raw.plant_year;
        if (raw.soil_type_id)
            meta.soil_type_id = raw.soil_type_id;
        if (raw.org_practises !== null)
            meta.org_practises = !!raw.org_practises;
        if (raw.art_irrigation !== null)
            meta.art_irrigation = !!raw.art_irrigation;
        if (raw.uses_biodynamic_methods !== null)
            meta.bio_methods = !!raw.uses_biodynamic_methods;
        if (raw.density)
            meta.density = +raw.density;
        if (raw.variety)
            meta.variety = raw.variety + '';
        if (raw.parcel_name)
            meta.parcel_name = raw.parcel_name;
        return meta;
    }
}
exports.default = SampleCoreMetadata;
